import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { EntitlementsGraphQLService } from './entitlements-graphql.service';

@Injectable({
  providedIn: 'root',
})
export class EntitlementsService {
  constructor(private entitlementsGraphQL: EntitlementsGraphQLService) {}

  private entitlements$ = this.entitlementsGraphQL.watch().valueChanges.pipe(
    map(result => result.data.patient.entitlements),
    catchError(() => observableOf([])), // Return empty array on error, which will result in false for all entitlements
    shareReplay(1), // Cache the latest result and replay to new subscribers
  );

  /**
   * Check if the user has a specific entitlement
   * @param entitlementName The entitlement name to check (e.g., 'MEMBERSHIP_REFERRAL')
   * @returns Observable<boolean> indicating if the entitlement is entitled
   */
  isEntitledTo(entitlementName: string): Observable<boolean> {
    return this.entitlements$.pipe(
      map(
        entitlements =>
          entitlements.find(e => e.name.toUpperCase() === entitlementName.toUpperCase())?.entitled ?? false,
      ),
    );
  }
}
